import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Switch } from '../ui/switch';
import { Building2, Clock, Save, Loader2 } from 'lucide-react';

const OrganizationTab = ({ orgForm, setOrgForm, handleOrgSave, saving }) => {
  return (
    <Card className="border-[#E2E6EA]">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Building2 className="h-5 w-5 text-[#00A3A3]" />
          Organization Settings
        </CardTitle>
        <CardDescription>Manage your company information and preferences</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label htmlFor="org-name">Company Name</Label>
            <Input
              id="org-name"
              value={orgForm.name}
              onChange={(e) => setOrgForm({ ...orgForm, name: e.target.value })}
              className="border-[#E2E6EA]"
              data-testid="org-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="timezone">Timezone</Label>
            <Select
              value={orgForm.timezone}
              onValueChange={(value) => setOrgForm({ ...orgForm, timezone: value })}
            >
              <SelectTrigger className="border-[#E2E6EA]">
                <Clock className="h-4 w-4 mr-2 text-[#5A6570]" />
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Asia/Manila">Asia/Manila (PHT)</SelectItem>
                <SelectItem value="Asia/Singapore">Asia/Singapore (SGT)</SelectItem>
                <SelectItem value="Asia/Hong_Kong">Asia/Hong Kong (HKT)</SelectItem>
                <SelectItem value="UTC">UTC</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label htmlFor="resolution-pattern">Resolution Numbering Pattern</Label>
            <Input
              id="resolution-pattern"
              value={orgForm.resolution_numbering_pattern}
              onChange={(e) => setOrgForm({ ...orgForm, resolution_numbering_pattern: e.target.value })}
              placeholder="{BODY}-{YEAR}-{SEQ}"
              className="border-[#E2E6EA]"
            />
            <p className="text-xs text-[#5A6570]">
              Available placeholders: {'{BODY}'}, {'{YEAR}'}, {'{SEQ}'}
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="principal-office">Principal Office</Label>
            <Input
              id="principal-office"
              value={orgForm.principal_office}
              onChange={(e) => setOrgForm({ ...orgForm, principal_office: e.target.value })}
              placeholder="123 Main Street, Makati City"
              className="border-[#E2E6EA]"
            />
            <p className="text-xs text-[#5A6570]">
              RCC Sec 49: Meetings held at principal office unless otherwise provided
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between p-4 bg-[#F8F9FA] rounded-lg">
          <div>
            <h4 className="font-medium text-[#1A1D21]">Allow Remote / Electronic Meetings</h4>
            <p className="text-sm text-[#5A6570]">
              Per RCC Sec 49 and SEC Memorandum Circular No. 6-2020
            </p>
          </div>
          <Switch
            checked={orgForm.remote_meetings_allowed}
            onCheckedChange={(checked) => setOrgForm({ ...orgForm, remote_meetings_allowed: checked })}
            data-testid="remote-meetings-switch"
          />
        </div>

        <div className="flex justify-end">
          <Button
            onClick={handleOrgSave}
            disabled={saving}
            className="bg-[#00A3A3] hover:bg-[#008585]"
            data-testid="save-org-btn"
          >
            {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Save className="h-4 w-4 mr-2" />}
            Save Changes
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default OrganizationTab;
